// บุคลิก (persona) ของตัวละครสำหรับโหมด "เลือกคำตอบจากไฟล์" — ข้อมูลคำตอบอยู่ที่ src/data/chatbot/chatbot_personas.json (ชื่อ persona ภาษาไทยเป็นคีย์)
//  id = ค่าที่เก็บใน characters/<id>.persona ; name = ชื่อ persona ในไฟล์ข้อมูล ; style = กติกาตกแต่งคำตอบแบบสุ่ม (คำขึ้นต้น/อีโมจิ/คำลงท้าย)
export const PERSONAS = [
  { id: "big_sister", name: "พี่สาว", label: "พี่สาวใจดี (พี่/น้อง)", prefix: ["อืม ", "นี่ "], emoji: ["🥰", "😊", "💕"], suffix: ["จ้า", "นะจ๊ะ"] },
  { id: "little_sister", name: "น้องสาว", label: "น้องสาวขี้อ้อน (หนู/พี่)", prefix: ["อืม ", "เอ๊ะ "], emoji: ["😆", "🥺", "💖"], suffix: ["น้า", "ค่า"] },
  { id: "big_brother", name: "พี่ชาย", label: "พี่ชายพูดน้อย (พี่/น้อง)", prefix: ["อืม ", "เออ "], emoji: [], suffix: [] },
  { id: "little_brother", name: "น้องชาย", label: "น้องชายขี้เล่น (ผม/พี่)", prefix: ["เอ่อ ", "อืม "], emoji: ["😎", "🎮", "😆"], suffix: ["ครับ"] },
  { id: "prince", name: "องค์ชาย", label: "องค์ชายภาษาโบราณ (ข้า/เจ้า)", prefix: ["อืม "], emoji: [], suffix: [] },
  { id: "chinese_girl", name: "สาวจีน", label: "สาวจีนร่าเริง (ฉัน/เธอ)", prefix: [], emoji: ["🍵", "🥟", "🐼"], suffix: ["จ้า"] },
  { id: "student", name: "นักเรียน", label: "เพื่อนนักศึกษา (เรา/เธอ)", prefix: ["อืม ", "เอ่อ "], emoji: ["😆", "😅", "✌️"], suffix: [] },
];
export const DEFAULT_PERSONA = "student"; // สรรพนามกลาง เรา/เธอ ใช้ได้กับทุกเพศ
export const personaById = (id) => PERSONAS.find((p) => p.id === id) || null;
export const personaByName = (name) => PERSONAS.find((p) => p.name === name) || null;
export const isPersonaId = (id) => !!personaById(id);

// เดาจากข้อความ/แท็กเมื่อตัวละครยังไม่ได้ตั้งค่า (ลำดับสำคัญ: ตรงตัวก่อน)
const GUESS = [
  ["chinese_girl", /จีน|你好|หนีห่าว|ตรุษจีน|chinese/i],
  ["prince", /องค์ชาย|เจ้าชาย|ขุนนาง|ย้อนยุค|โบราณ|ในวัง|\bprince\b/i],
  ["big_sister", /พี่สาว|ครูที่ปรึกษา|ครู|เชฟ|พี่เลี้ยง/],
  ["little_sister", /น้องสาว|เด็กสาว|เพื่อนบ้านสดใส/],
  ["big_brother", /พี่ชาย|รุ่นพี่|กัปตัน|พี่ภูผา|พี่เขย/],
  ["little_brother", /น้องชาย|น้องเล็ก/],
  ["student", /นักศึกษา|นักเรียน|มหาลัย|มหาวิทยาลัย|เพื่อนสนิท|เกมเมอร์/],
];
/** ch = {persona, name, tagline, description, tagIds} -> id ของ persona (ใช้ค่าที่ตั้งไว้ก่อน ไม่งั้นเดา ไม่ได้ก็ค่าเริ่มต้น) */
export function resolvePersona(ch) {
  const c = ch || {};
  if (isPersonaId(c.persona)) return c.persona;
  const hay = [c.name, c.tagline, c.description].filter(Boolean).join(" ").slice(0, 600);
  const tags = Array.isArray(c.tagIds) ? c.tagIds : [];
  if (tags.indexOf("noble") !== -1) return "prince";
  for (let i = 0; i < GUESS.length; i++) if (GUESS[i][1].test(hay)) return GUESS[i][0];
  return DEFAULT_PERSONA;
}

// ---- ตกแต่งแบบกฎ -------------------------------------------------------------------------------
// หัวข้อที่ไม่ควรเติมอะไรเลย (อารมณ์หนัก/จริงจัง) ; คำขึ้นต้น/คำลงท้ายเติมเฉพาะหัวข้อคุยเล่น (CASUAL) เพราะต่อหน้าประโยคอื่นแล้วอาจแปลก
const SERIOUS = new Set(["sad", "sick", "angry", "lonely", "need_encouragement", "work_stress", "cant_sleep", "are_you_bot", "flirt", "unknown_fallback", "sulk", "sorry", "confused"]);
const CASUAL = new Set(["greeting_hello", "how_are_you", "doing_what", "food_talk", "hobby", "music", "movie", "game", "travel", "weekend_plan", "small_talk_generic", "joke", "pet", "lets_chat", "weather_hot", "hungry", "bored", "bored_suggest", "laugh", "good_morning", "ate_yet"]);
const ENDS_PARTICLE = /(จ้า|จ้ะ|จ๊ะ|ครับ|ค่ะ|คะ|ค่า|นะ|น้า|เถิด|เลย|ล่ะ|เนอะ|อ่ะ|ๆ|555)$/;
const ENDS_QUESTION = /(ไหม|มั้ย|เหรอ|หรือเปล่า|รึเปล่า|หรือยัง|รึยัง|ยัง|อะไร|ใคร|ไหน|เท่าไหร่|ทำไม|ยังไง|เปล่า|สิ|ซิ|ด้วย|บ้าง|หน่อย)$/;
const ENDS_THAI = /[\u0e01-\u0e4e]$/;
const startsEmoji = /^\p{Extended_Pictographic}/u;
const hasEmoji = (t) => /\p{Extended_Pictographic}/u.test(t);

/**
 * ตกแต่งคำตอบตามบุคลิกด้วยความน่าจะเป็น ; rng = () => [0,1) (ฉีดได้เพื่อทดสอบ)
 * คืนข้อความใหม่ (ไม่เปลี่ยนความหมาย) — ไม่แตะข้อความที่มีอีโมจิอยู่แล้ว/หัวข้อจริงจัง
 */
export function decorate(text, persona, intent, rng = Math.random) {
  const p = typeof persona === "string" ? personaById(persona) : persona;
  let t = String(text || "");
  if (!p || !t || SERIOUS.has(intent)) return t;
  const pick = (arr) => arr[Math.floor(rng() * arr.length) % arr.length];
  const casual = CASUAL.has(intent);
  if (casual && p.prefix.length && rng() < 0.12 && !startsEmoji.test(t) && t.length < 60) t = pick(p.prefix) + t;
  if (casual && p.suffix.length && rng() < 0.15 && ENDS_THAI.test(t) && !ENDS_PARTICLE.test(t) && !ENDS_QUESTION.test(t) && t.length < 70) t += pick(p.suffix);
  if (p.emoji.length && rng() < 0.3 && !hasEmoji(t)) t += " " + pick(p.emoji);
  return t;
}
